const baseURL = 'https://jhonazaelcolor.com';

export default baseURL;
